import getGuideInfoList from './getGuideInfoList';
import activateGuideApp from './activateGuideApp';
import applyActivateGuideApp from './applyActivateGuideApp';
export default {
    /** 获取引导页信息 */
    getGuideInfoList,
    /** 引导页实例激活 */
    activateGuideApp,
    /** 应用商店批量申请开通 */
    applyActivateGuideApp,
};


// WEBPACK FOOTER //
// ./src/api/gettingStarted/index.ts